import { useQueryState } from "nuqs";
import { useEffect } from "react";
import useBusiness from "./use-business";

export const BUSINESS_PARAM = "business";

export const useBusinessInUrl = () => {
  const { businessId } = useBusiness();
  const [urlBusinessId, setUrlBusinessId] = useQueryState(BUSINESS_PARAM, {
    history: "replace",
    shallow: false,
  });
  useEffect(() => {
    if (businessId && !urlBusinessId) void setUrlBusinessId(businessId);
  }, [businessId, urlBusinessId, setUrlBusinessId]);
};
